<template>
  <div class="header">
    <!-- <img class="head" :src="webInfoObj.strPicUrl" alt="" /> -->
     <img class="head" src="../../assets/images/top-bg.jpg" alt="" srcset="">
     <img class="head-logo" src="../../assets/images/logo.png" alt="" srcset="">
  </div>
</template>

<script>
export default {
  name: 'Head',
  components: {},
  data() {
    return {
      strId: '',
      navigations: []
    }
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => []
    }
  },
  watch: {
    $route(to, from) {
      this.strId = this.$route.query.strId
    }
  },
  methods: {
    // 首页跳转
    indexHandle() {
      this.$router.push({
        path: '/index',
        query: { strWebSiteId: this.$route.query.strWebSiteId }
      })
    },

    // 菜单跳转
    navHandle(strId) {
      this.$router.push({
        path: '/list',
        query: { strId: strId, strWebSiteId: this.$route.query.strWebSiteId }
      })
    }
  }
}
</script>

<style scoped lang="less">
.header {
  box-sizing: border-box;
  position: relative;

  .head {
    display: block;
    width: 100%;
    height: auto;
    margin: 0 auto;
    min-width: 1250px;

    width: 100%;
    height: 630px;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
  }
  .head-logo {
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
